<script setup>
import { computed } from 'vue'
import { positiveInteger } from '../../services/process/ProcessMetrics'
const props = defineProps({ modelValue: { type: [Number, String], default: null }, readonly: Boolean })
const emit = defineEmits(['update:modelValue'])
const notApplicable = computed({
  get: () => props.modelValue == null,
  set: value => emit('update:modelValue', value ? null : '')
})
</script>

<template>
  <div>
    <v-checkbox v-model="notApplicable" label="Gramaje: No aplica" :readonly="readonly" hide-details density="comfortable" />
    <v-text-field
      v-if="!notApplicable" :model-value="modelValue" label="Gramaje" type="number" min="1" step="1"
      :readonly="readonly" :rules="[positiveInteger]"
      @update:model-value="emit('update:modelValue', $event === '' ? '' : Number($event))" />
  </div>
</template>
